import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "@/stores";

const actions = () => ({
  async createLivelihood(payload) {
    await api.post("/api/livelihood/questionnaire", payload);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "Livelihood questionnaire has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/livelihood/questionnaire/overview");
  },

  async editLivelihood(payload) {
    await api.post(`/api/livelihood/questionnaire/${payload.id}`, payload.data);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    // router.push("/dashboard");
  },

  async getLivelhoodOverview(payload) {
    const res = await api.get("/api/livelihood/questionnaire/overview", {
      params: payload,
    });
    this.overview = res.data.content;
    this.pagination.totalItems = res.data.totalElements;
    this.pagination.cuurentPage = res.data.number + 1;
    this.pagination.pageCount = res.data.totalPages;
  },

  async deleteLivelihood(payload) {
    await api.post(`/api/livelihood/questionnaire/${payload.id}/delete`);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "Livelihood has been deleted",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/livelihood/overview");
  },

  async downloadExcel(payload) {
    try {
      const response = await api.get(
        "/api/livelihood/questionnaire/overview/export",
        {
          params: payload,
          responseType: "blob",
        }
      );

      return response;
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  },

  async getLivelihood(payload) {
    const res = await api.get(`/api/livelihood/questionnaire/${payload.id}`);
    return res.data;
  },

  resetAction() {
    this.filters.keyword = null;
    this.filters.advanced = {
      name: null,
      jobFoundMethod: null,
      didOdysseaSupport: null,
      branch: null,
      employerName: null,
      partOfNetwork: null,
      fieldOfEmployment: null,
      jobTitleId: null,
      typeOfEmployment: null,
      durationOfContract: null,
      netSalaryRange: [],
      dateDates: [],
      startDates: [],
      endDates: [],
      route: [],
      trainingType: [],
      odysseaSupport: null,
      socialSecurity: null,
      jobSatisfactionLevel: null,
      helpsGrow: null,
      feelSecureInJob: null,
      getAlong: null,
      jobMatchSkills: null,
      recommendEmployer: null,
      stillLookingForJob: null,
      newJobLookingFor: null,
      intakeProjects: [],
    };
  },
});

export default actions;
